import type { ClienteRanking, FiltroRanking } from "../../../services/posicaoClientes"

export enum PosicaoClientesActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_FILTRO = "ATUALIZAR_FILTRO",
    SORTEAR = "SORTEAR",
}

export type PosicaoClientesAction =
    | {
          type: PosicaoClientesActionsTypes.CARREGAR
          payload: ClienteRanking[]
      }
    | {
          type: PosicaoClientesActionsTypes.ATUALIZAR_FILTRO
          payload: { campo: keyof FiltroRanking; valor: string | number }
      }
    | {
          type: PosicaoClientesActionsTypes.SORTEAR
      }
